import React, { useCallback, useMemo, Suspense } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import classNames from 'classnames'
import Table from './Table'

const ResponsivePdf = React.lazy(() => import('components/ResponsivePdf'))

const Plot = ({ lodir }) => {
  const pdfBasepath = '/maeli-lodablod'
  const { lod } = useParams()
  let formHref = null
  let formTitle = 'Smelltu hér til þess að sækja um lóð'
  const setRef = useCallback(
    (node) => {
      if (node && lod) {
        window.scrollTo({ top: node.offsetTop, behavior: 'smooth' })
      }
    },
    [lod]
  )

  const data = useMemo(() => {
    return lodir ? lodir.find((item) => item.slug === lod) : null
  }, [lod, lodir])

  if (!data.seld && data.form_id) {
    formHref = new URL(`https://ibuagatt.akranes.is/form/${data.form_id}`)
    formHref.searchParams.set('lod_heiti', data.title)
    formHref.searchParams.set('lod_lnr', data.landnumer)
    formHref.searchParams.set('lod_tegund', data.lodargerd)
    formHref.searchParams.set('lod_staerd', data.lodarstaerd)

    formHref = formHref.toString()
    formHref = formHref.replace('+', '%20')
  }

  if (data.byggingarrettargjald_utbod) {
    formHref = new URL('https://akranes.ajoursystem.net/')
    formTitle = 'Smellið hér til að senda inn tilboð'
  }

  return (
    <>
      <Row
        ref={setRef}
        className={classNames('align-items-center m-0 h-100 justify-content-center', {
          'bg-primary': data,
        })}
      >
        {data ? (
          <>
            <Col className="py-4 py-lg-6">
              <h4 className="text-center text-white pb-4 m-0">{data.title}</h4>
              <Table data={data} />
              {formHref ? (
                <a
                  href={formHref.toString()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center text-white py-3"
                >
                  {formTitle}
                </a>
              ) : null}
            </Col>

            <Col
              md={6}
              lg={7}
              className="text-center p-4 bg-white align-self-stretch justify-content-center"
            >
              {data.pdf_skra ? (
                <>
                  <Suspense fallback={<p>Hleð...</p>}>
                    <ResponsivePdf file={`${pdfBasepath}/${data.pdf_skra}`} />
                  </Suspense>
                  <a
                    href={`${pdfBasepath}/${data.pdf_skra}`}
                    className="py-3 d-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Smelltu hér til að skoða lóðarblað í sér glugga
                  </a>
                </>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <h4>Lóðarblað fannst ekki.</h4>
                </div>
              )}
            </Col>
          </>
        ) : (
          <h2 className="text-center py-6">Lóð fannst ekki</h2>
        )}
      </Row>
    </>
  )
}

export default React.memo(Plot)
